<template>
  <div>
    <div class="break-header pb-3 px-2">
      <h3 class="break-heading">
        Price&nbsp;Breaks:&nbsp;<span class="font-weight-bold">{{ rate.carrier_service.name }}&nbsp;-&nbsp;{{ rate.zone_from.desc }}&nbsp;to&nbsp;{{ rate.zone_to.desc }}</span>
      </h3>

      <div>
        <el-button
          v-if="canCreate"
          size="small"
          round
          @click.native="createBreak"
        >
          <FontAwesomeIcon
            :icon="['fal', 'plus']"
            fixed-width
          />&nbsp;Create
        </el-button>
        <el-button
          size="small"
          round
          @click.native="loadTable"
        >
          <FontAwesomeIcon
            :icon="['fal', 'sync']"
            fixed-width
          />&nbsp;Refresh
        </el-button>
      </div>
    </div>
    <el-card shadow="never">
      <el-table
        v-loading="isLoading"
        size="mini"
        :data="breaks.slice()"
        stripe
      >
        <el-table-column
          label="Type"
          prop="rate_type"
          min-width="80px"
          show-overflow-tooltip
          :formatter="(row, col, cellValue) => cellValue ? (cellValue.short || '-') : '-' "
        />
        <el-table-column
          label="Break"
          prop="break"
          min-width="80px"
          show-overflow-tooltip
          :formatter="(row, col, cellValue) => cellValue ? (cellValue || '0') : '0' "
        />
        <el-table-column
          label="Basic"
          prop="basic"
          min-width="80px"
          show-overflow-tooltip
          :formatter="(row, col, cellValue) => cellValue ? (cellValue || '0') : '0' "
        />
        <el-table-column
          label="Rate"
          prop="cost"
          min-width="80px"
          show-overflow-tooltip
          :formatter="(row, col, cellValue) => cellValue ? (cellValue || '0') : '0' "
        />
        <el-table-column
          v-if="canUpdate || canDelete"
          label="Actions"
          align="right"
          min-width="160px"
        >
          <template slot-scope="scope">
            <el-button
              v-if="canUpdate"
              size="mini"
              @click.native="editBreak(scope.$index, scope.row)"
            >
              Edit
            </el-button>
            <el-button
              v-if="canDelete"
              size="mini"
              type="danger"
              @click.native="deleteBreak(scope.$index, scope.row)"
            >
              Delete
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- Edit Form -->
    <RateCardBreakEditForm
      v-if="isShowEditForm"
      ref="editForm"
      :rate="rate"
      :price-break="priceBreak"
      :is-show.sync="isShowEditForm"
      @saved="loadTable"
    />
  </div>
</template>

<script>
import RateCardBreakEditForm from '@/components/Application/Manage/RateCards/RateCardBreakEditForm'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'
export default {
  components: {
    RateCardBreakEditForm
  },
  props: {
    rate: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      breaks: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: false,
      isShowEditForm: false,
      priceBreak: null
    }
  },
  computed: {
    canCreate () {
      return this.$user.can(CREATE, 'ratecard_pricebreak')
    },
    canUpdate () {
      return this.$user.can(UPDATE, 'ratecard_pricebreak')
    },
    canDelete () {
      return this.$user.can(DELETE, 'ratecard_pricebreak')
    }
  },
  created () {
    this.loadTable()
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.ratecard_rate.read(this.rate.id, (builder) => {
        builder.include = ['price_breaks', 'zone_from', 'zone_to', 'carrier_service']
        builder.page = this.page
        builder.limit = this.perPage
      })
        .then(res => {
          this.breaks = res.price_breaks
          this.total = res.price_breaks.length
        })
        .finally(() => { this.isLoading = false })
    },
    createBreak () {
      this.priceBreak = new this.$sdk.ratecard_pricebreak()
      this.isShowEditForm = true
    },
    editBreak (index, row) {
      this.priceBreak = row
      this.isShowEditForm = true
    },
    deleteBreak (index, row) {
      this.$confirm('Are you sure you want to delete this Price Break?', 'Notice', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        dangerouslyUseHTMLString: true,
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        this.$sdk.ratecard_pricebreak.delete(row.id)
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.break-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .break-heading {
      margin: 0;
    }
}
</style>
